import { USER_INFO } from "@constants/auth.constant";
import { IAppRoutes } from "@interface/common.interface";
import { LocalStorageService } from "@services/utils/localStorage.service";

// Roles that bypass feature gating and see every route.
const SUPER_ROLES = ["COMPANY_ADMIN"];

export type Access = { features: any[] | undefined; isSuperAdmin: boolean };

/**
 * The signed-in user's grants. Call it at render time, never at module scope: module scope runs
 * once at app boot, before login, and every gated page then says "Permission denied!" until a
 * full reload.
 */
export const readAccess = (): Access => {
  const userInfo: any = LocalStorageService.get(USER_INFO);
  return {
    features: userInfo?.features,
    // COMPANY_ADMIN bypasses feature gating (and can always reach ACL/user management).
    isSuperAdmin: SUPER_ROLES.includes(userInfo?.roleKey || userInfo?.roleName),
  };
};

/** One rule set for both the routes and the sidebar, so a menu link can never outrun its page. */
export const isAllowed = (route: Pick<IAppRoutes, "routeCode" | "adminOnly"> | undefined, access: Access) => {
  if (!route) return true;
  if (route.adminOnly && !access.isSuperAdmin) return false;
  if (access.isSuperAdmin || !route.routeCode) return true;
  return !!access.features?.some((f) => f.code === route.routeCode);
};
